/**
 * Section 3 — Disclosures and Transfers of Information
 * Exact legal text from the approved Privacy Policy prototype.
 */

import { BulletPoint } from '../BulletPoint';

export const DisclosuresAndTransfers = () => (
  <div className="font-termina text-xl max-md:text-2xl">
    <h2 className="font-recoleta font-black">
      3. Disclosures and Transfers of Information
    </h2>
    <div className="w-full font-termina">
      <br />
      We do not sell your personal information or exchange it for value as part
      of a contract. We share personal information with third parties in the
      following situations:
    </div>
    <br />

    <BulletPoint>
      We have your consent to make the disclosure, for example when you request
      a consult with a Provider;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is necessary for the purpose for which the personal
      information was obtained;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is to the Provider from whom you purchased services through
      bQuest's platform and such disclosure is necessary for that Provider to
      provide their services;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is to payment processors in order to fulfill and carry out
      your purchase;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is required by applicable law;
    </BulletPoint>
    <br />

    <BulletPoint>
      The personal information to be disclosed is otherwise publicly available
      in accordance with applicable law;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is reasonably related to the sale or other disposition of
      all or part of our business or assets;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is for our own marketing purposes (including, without
      limitation, for bQuest to market services to you on social media
      platforms), or, with your consent, for the marketing purposes of third
      parties;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is combined with information collected from other companies
      and used to improve and personalize services, content, and advertising
      from us;
    </BulletPoint>
    <br />

    <BulletPoint>
      The party to whom the disclosure is made controls, is controlled by, or is
      under common control with bQuest;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is, in our sole discretion, necessary for the establishment
      or maintenance of legal claims or legal compliance, to satisfy any law,
      regulation, subpoena or government request; to protect the health and
      safety of you, a third person, or the bQuest Platform; or in connection
      with litigation;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is in our sole discretion about users who we believe are
      engaged in illegal activities or are otherwise in violation of our Terms
      of Use, even without a subpoena, warrant or court order;
    </BulletPoint>
    <br />

    <BulletPoint>
      The disclosure is to third party service providers to perform certain
      services for us, such as maintaining our Services, mailing lists,
      processing orders, sending mail, processing claims, providing marketing
      assistance, confirming your identity, and data analysis ("Administrative
      Providers"), including Administrative Providers outside the country or
      jurisdiction in which you reside;
    </BulletPoint>
    <br />

    <span className="flex">
      <div className="w-full font-termina">
        Prior to sharing of your personal information with others, bQuest will
        make agreements with Administrative Providers and other third party
        service providers to provide for the allowable use and security of the
        transferred information in accordance with this Privacy Policy and
        applicable law. If bQuest becomes aware that any such outside party is
        improperly using or disclosing personal information, it will notify that
        outside party and request that it take reasonable steps to cease such
        use or disclosure.
      </div>
    </span>
    <br />

    <span className="flex">
      <div className="w-full font-termina">
        We may disclose your name and address to Providers when you submit
        Feedback relating to those Providers. If you properly notify us through
        your account that you no longer want us to share your personal
        information, we will cease sharing your personal information except as
        absolutely necessary to provide the Services you have requested.
        However, except as otherwise stated in this Privacy Policy, we do not
        directly control the third parties to which we share such personal
        information and you must further notify such third parties directly if
        you would like them to cease use of your personal information.
      </div>
    </span>
    <br />

    <span className="flex">
      <div className="w-full font-termina">
        We may also disclose anonymous User information for any legally
        permissible purpose, including without limitation in order to describe
        the use of the Services to our existing or potential business partners
        or other third parties, or in response to a government request. We may
        also share aggregated demographic and preference data with third parties
        to enable the provision of targeted information, promotions, offers
        and/or discounts on products and services.
      </div>
    </span>
    <br />
    <br />
  </div>
);
